import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const HeroContainer = styled(Box)({
  position: 'relative',
  minHeight: '100vh',
  width: '100%',
  backgroundColor: '#1a1a1a',
  overflow: 'hidden',
});

const StyledImage = styled('img')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  opacity: 0.7,
  objectPosition: 'center center',
});

const HeroContent = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
  color: '#fff',
  width: '90%',
  maxWidth: '800px',
  zIndex: 1,
});

const HeroTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '3.5rem',
  marginBottom: '1.5rem',
  '@media (max-width: 600px)': {
    fontSize: '2.5rem',
  },
});

const HeroSubtitle = styled(Typography)({
  fontSize: '1.2rem',
  marginBottom: '2rem',
  '@media (max-width: 600px)': {
    fontSize: '1rem',
  },
});

const HeroButton = styled(Button)({
  backgroundColor: '#c4a661',
  color: '#fff',
  padding: '1rem 2rem',
  fontSize: '1.1rem',
  '&:hover': {
    backgroundColor: '#9a834d',
  },
});

const Hero = () => {
  return (
    <HeroContainer>
      <StyledImage
        src="https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
        alt="Luxury Jewelry Collection"
      />
      <HeroContent>
        <HeroTitle variant="h1">
          Your #1 Connect for all your custom jewelry needs
        </HeroTitle>
        <HeroSubtitle>
          Explore our collection of exquisite jewelry pieces
        </HeroSubtitle>
        <HeroButton
          component={Link}
          to="/collections"
          variant="contained"
          disableElevation
        >
          Shop Now
        </HeroButton>
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
